<!-- Countries Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <!-- Search Input -->
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input
          type="text"
          class="form-control form-control-solid w-250px ps-13"
          placeholder="Search countries..."
          [(ngModel)]="searchTerm"
          (keyup)="onSearchInput($event)"
        />
      </div>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-country-table-toolbar="base">
        <!-- Add Country Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddCountryModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Country
        </button>
      </div>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="card-body border-bottom py-4" *ngIf="showFiltersForm" [@slideInOut]>
    <div class="row g-4">
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Search Countries</label>
        <div class="d-flex align-items-center position-relative">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-3">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input
            type="text"
            class="form-control form-control-sm ps-10"
            placeholder="Search countries..."
            [(ngModel)]="searchTerm"
            (keyup.enter)="applyFilters()"
          />
        </div>
      </div>
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Date From</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.date_from"
        />
      </div>
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Date To</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.date_to"
        />
      </div>
      <div class="col-md-3 d-flex align-items-end">
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-sm btn-primary" (click)="applyFilters()">
            <i class="ki-duotone ki-magnifier fs-3">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Search
          </button>
          <button type="button" class="btn btn-sm btn-secondary" (click)="clearFilters()">
            <i class="ki-duotone ki-cross fs-3">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Clear
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Countries Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-200px">Country Name</th>
            <th class="min-w-150px">Region</th>
            <th class="min-w-150px">Parent Country</th>
            <th class="min-w-150px">Port</th>
            <th class="min-w-200px">Inspection</th>
            <th class="min-w-150px">Ship Method</th>
            <th class="min-w-120px">Created Date</th>
            <th class="min-w-100px text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr *ngIf="isLoading">
            <td colspan="8" class="text-center py-5">
              <div class="d-flex align-items-center justify-content-center">
                <div class="spinner-border spinner-border-sm text-primary me-2"></div>
                <span class="text-muted">Loading countries...</span>
              </div>
            </td>
          </tr>

          <!-- Empty State -->
          <tr *ngIf="!isLoading && countries.length === 0">
            <td colspan="8" class="text-center py-5">
              <div class="text-center">
                <i class="ki-duotone ki-information-5 fs-1 text-primary mb-3">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                </i>
                <p class="text-muted fs-6 mb-0">No countries found</p>
              </div>
            </td>
          </tr>

          <!-- Data Rows -->
          <tr *ngFor="let country of countries; trackBy: trackByFn">
            <td>
              <div class="d-flex align-items-center">
                <div class="symbol symbol-45px me-5">
                  <div class="symbol-label bg-light-primary">
                    <i class="ki-duotone ki-geolocation fs-2 text-primary">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </div>
                </div>
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">
                    {{ country.name || '-' }}
                  </span>
                </div>
              </div>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ country.region || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ country.parent?.name || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ country.port?.name || '-' }}
              </span>
            </td>
            <td>
              <div class="d-flex flex-wrap gap-1">
                <span *ngFor="let inspection of country.inspection" class="badge badge-light-info fs-8">
                  {{ inspection }}
                </span>
                <span *ngIf="!country.inspection || country.inspection.length === 0" class="text-muted">-</span>
              </div>
            </td>
            <td>
              <div class="d-flex flex-wrap gap-1">
                <span *ngFor="let method of country.ship_method" class="badge badge-light-success fs-8">
                  {{ method }}
                </span>
                <span *ngIf="!country.ship_method || country.ship_method.length === 0" class="text-muted">-</span>
              </div>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ country.created_at | date:'dd/MM/yyyy' }}
              </span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Edit Button -->
                <button type="button"
                        class="btn btn-sm btn-icon btn-light-primary"
                        (click)="openEditCountryModal(country)"
                        title="Edit Country">
                  <i class="ki-duotone ki-pencil fs-6">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Button -->
                <button type="button"
                        class="btn btn-sm btn-icon btn-light-danger"
                        (click)="deleteCountry(country)"
                        title="Delete Country">
                  <i class="ki-duotone ki-trash fs-6">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <app-pagination
      *ngIf="!isLoading && countries.length > 0"
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>

<!-- Country Add/Edit Modal -->
<app-add-edit-country
  (countryAdded)="onCountryAdded()"
  (countryUpdated)="onCountryUpdated()">
</app-add-edit-country>
